define('TescoMobile_Checkout/js/action/save-family-perk',['jquery', 'Magento_Checkout/js/model/quote', '../model/choice-resource-url-manager', '../model/insurance', 'mage/storage', 'underscore', 'Magento_Customer/js/customer-data'], function ($, quote, urlManager, insuranceModel, storage, _, customerData) {
  'use strict';

  return function (quoteItemId, insuranceSku) {
    let insurancePerkRemoved = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let deferred = arguments.length > 3 ? arguments[3] : undefined;
    deferred = deferred || $.Deferred();
    if (_.isObject(quoteItemId) && quoteItemId.hasOwnProperty('id')) {
      quoteItemId = quoteItemId.id;
    }
    var serviceUrl = urlManager.getUrlForSaveFamilyPerk(quote, quoteItemId, insuranceSku);
    return storage.post(serviceUrl).done(function (response) {
      var cartData = customerData.get('cart'),
        dataId = cartData().data_id;
      insuranceModel.quoteItemId = response.id;
      if (insurancePerkRemoved === true) {
        $(document).trigger("insurance-related-perk-removed");
        $(document).trigger("insuranceSaved", dataId);
        $(document).trigger("insuranceClosed");
      }
      deferred.resolve(response);
    }).fail(function (response) {
      var body = response.responseJSON ? response.responseJSON : response.responseText;
      deferred.reject(body);
    });
  };
});

